<template>
    <el-dialog
        title="添加库存"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="390px"
        center>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
            <el-form-item prop="num" label="社区">
                <el-select class="w-100" v-model="ruleForm.cid" multiple placeholder="请选择" filterable>
                    <el-option v-for="(item,index) in org_list" :key="index"
                               :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="num" label="库存数量">
                <el-input-number style="width: 100%" v-model="ruleForm.num" placeholder="请输入" :min="1" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('ruleForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>


import {getXiangMuList} from "@/api/common";
import {addProductXiangmuNum} from "@/api/weilao";

export default {
    name: "AddShoppingNumDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        pid: {
            type:[Number,String],
            default: ''
        }
    },
    data() {

        return {
            org_list:[],
            ruleForm: {
                cid:[],
                num: 1,
            },
            rules: {
                cid: [{required: true, message: '请选择社区', trigger: 'change'}],
                num: [{required: true, message: '请输入数量', trigger: 'change'}],
            }
        }
    },
    computed: {

    },
    created() {
        this.getOrgList()
    },
    methods: {
        async getOrgList() {
            let _data = await getXiangMuList()
            this.org_list = _data.data
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('watchState', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _data = await addProductXiangmuNum(
                this.pid,
                this.ruleForm.cid.join(','),
                this.ruleForm.num,
            );
            if (_data.status === 200) {
                this.$message.success('保存成功')
                this.$refs[formName].resetFields();
                this.$emit("watchState", true);
            } else {
                this.$message.error(_data.info)
            }

        }

    },
    watch: {
    }
}
</script>

<style scoped lang="scss">

</style>
